export default {
  jobs: {
    intro: `
      <h2>Before you go...</h2>
      <p>Sign up to RateMyAppprenticeship.co.uk and get personalised job alerts straight to your inbox!</p>
    `,
  },
  companies: {
    intro: `
      <h2>Before you go...</h2>
      <p>Sign up to RateMyAppprenticeship.co.uk and get personalised company alerts straight to your inbox!</p>
    `,
  },
  gdprStatement: `
      <p class="AuthRegister-optinCopy">
        By signing up you agree to our <a href="/terms-and-conditions">Terms of Use</a>.  We will process your information in accordance with our <a href="/privacy-policy">Privacy Policy</a>.
      </p>
  `,
};
